import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: number
  email: string
  full_name: string
  role: string
  language: string
}

interface AgentState {
  // Auth
  user: User | null
  accessToken: string | null
  isAuthenticated: boolean
  setUser: (user: User | null) => void
  setToken: (token: string | null) => void
  logout: () => void

  // UI
  isDarkMode: boolean
  isSidebarOpen: boolean
  language: string
  toggleDarkMode: () => void
  toggleSidebar: () => void
  setLanguage: (lang: string) => void

  // Dashboard data
  selectedElderlyId: number | null
  setSelectedElderlyId: (id: number | null) => void
}

export const useAgentStore = create<AgentState>()(
  persist(
    (set) => ({
      // Auth defaults
      user: null,
      accessToken: null,
      isAuthenticated: false,
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      setToken: (token) => set({ accessToken: token }),
      logout: () => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        set({ user: null, accessToken: null, isAuthenticated: false })
      },

      // UI defaults
      isDarkMode: false,
      isSidebarOpen: true,
      language: 'en',
      toggleDarkMode: () => set((state) => ({ isDarkMode: !state.isDarkMode })),
      toggleSidebar: () => set((state) => ({ isSidebarOpen: !state.isSidebarOpen })),
      setLanguage: (lang) => set({ language: lang }),

      // Data
      selectedElderlyId: null,
      setSelectedElderlyId: (id) => set({ selectedElderlyId: id }),
    }),
    {
      name: 'senior-care-agent-storage',
      partialize: (state) => ({
        user: state.user,
        accessToken: state.accessToken,
        isDarkMode: state.isDarkMode,
        language: state.language,
        selectedElderlyId: state.selectedElderlyId,
      }),
    }
  )
)